// default annotations that have inline comment enabled on select
export default [
  window.Core.Annotations.TextUnderlineAnnotation,
  window.Core.Annotations.TextHighlightAnnotation,
  window.Core.Annotations.FreeTextAnnotation,
  window.Core.Annotations.CaretAnnotation,
  window.Core.Annotations.StickyAnnotation,
  window.Core.Annotations.TextSquigglyAnnotation,
  window.Core.Annotations.TextStrikeoutAnnotation,
];